import { getDataMapper, mapArray, mapField } from "@/shared";

// Маппер для отдельного промокода (из сервера)
export const mapPromocodeFromServer = getDataMapper({
    id: mapField("id", Number),
    code: mapField("code"),
    discount: mapField("discount", Number),
    count: mapField("count", Number),
    groupOfUserId: mapField("group_of_user_id"),
    expiresAt: mapField("expires_at"),
    usagesCount: mapField("usages_count", Number),
    isActive: mapField("is_active", Boolean),
    createdAt: mapField("created_at"),
});

// Маппер для массива промокодов
export const mapPromocodesFromServer = mapArray(mapPromocodeFromServer);
